/* ============================================================================
   haiku-nav — clone the two header links in, then (and only then) allow the
   hamburger to be hidden on desktop.

   ORDER MATTERS. The `hnav` class is set AFTER the links are verified to be in
   the DOM. Every CSS rule that hides the stock opener is scoped to body.hnav.
   If this script never runs the site keeps its hamburger and its navigation.
   ========================================================================== */
(function () {
  'use strict';

  function mount() {
    var tpl = document.getElementById('haiku-nav-tpl');
    if (!tpl || !tpl.content) return;

    // The right-hand control cluster. Fall back through a couple of selectors
    // rather than assuming one theme class survives an update.
    var search = document.getElementById('search-open-button');
    var host = search && search.parentElement;
    if (!host) {
      var mode = document.querySelector('.hi-mode-btn');
      host = mode && mode.parentElement;
    }
    if (!host) return;

    var frag = tpl.content.cloneNode(true);
    var links = frag.querySelectorAll('.hn-link');
    if (!links.length) return;

    // Place them immediately after search so the cluster reads
    // search · wardrobe · about, left to right.
    /* Before search, so the cluster reads wardrobe · story · search and the
       order does not change when search is hidden off the wardrobe. */
    if (search && search.parentElement === host) {
      host.insertBefore(frag, search);
    } else {
      host.appendChild(frag);
    }

    /* Verify the clones LANDED — not that they are visible.
       They are display:none until body.hnav exists, so a getBoundingClientRect
       check here is circular: the class grants the layout the check demands,
       so the check can never pass and the layer never activates. (It passed by
       accident while .menu-meta__link's display:flex was winning on equal
       specificity; fixing that specificity exposed the bug.)
       Connectedness inside the header is the real precondition. */
    var placed = document.querySelectorAll('.hn-link');
    if (placed.length < 2) return;
    var ok = true;
    for (var i = 0; i < placed.length; i++) {
      if (!placed[i].isConnected || !host.contains(placed[i])) { ok = false; break; }
    }
    if (!ok) return;

    document.body.classList.add('hnav');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
  else mount();
})();
